import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./assets/less/main.less";
import "../node_modules/swing-ui/dist/css/swing.min.css";
import App from "./components/App.tsx";
import ErrorBoundary from "./components/ErrorBoundary.tsx";
import { getCampaignSourceCode } from "./lib";

const containers = document.getElementsByClassName("sak-engagement-app");
Array.from(containers).forEach((container) => {
  const campaignSourceCode = getCampaignSourceCode();

  const dataAttrs = (container as HTMLElement).dataset;
  const childId = dataAttrs.childId || "";
  const limitedTrustHandshake = dataAttrs.limitedTrustHandshake || "";
  const limitedTrustMarker = dataAttrs.limitedTrustMarker || "";
  const supporterName = dataAttrs.supporterName || "";
  const supporterNumber = dataAttrs.supporterNumber || "";
  const supporterState = dataAttrs.supporterState || "";

  createRoot(container).render(
    <StrictMode>
      <ErrorBoundary fallbackMessage="Something went wrong with the application. Please try refreshing the page, or call support if the problem persists.">
        <App
          campaignSourceCode={campaignSourceCode}
          childId={childId}
          limitedTrustHandshake={limitedTrustHandshake}
          limitedTrustMarker={limitedTrustMarker}
          supporterName={supporterName}
          supporterNumber={supporterNumber}
          supporterState={supporterState}
        />
      </ErrorBoundary>
    </StrictMode>
  );
});
